/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Advantages_CitationsInputs */

const en_homepage_advantages_citations = /** @type {(inputs: Homepage_Advantages_CitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inline citations`)
};

const es_homepage_advantages_citations = /** @type {(inputs: Homepage_Advantages_CitationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Citas en línea`)
};

/**
* | output |
* | --- |
* | "Inline citations" |
*
* @param {Homepage_Advantages_CitationsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_advantages_citations = /** @type {((inputs?: Homepage_Advantages_CitationsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Advantages_CitationsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_advantages_citations(inputs)
	return en_homepage_advantages_citations(inputs)
});